<template>
    <inertia-head v-if="!campaignSlug">
        <title>{{ title }}</title>
        <link rel="canonical" :href="canonical">
        <meta name="description" :content="`Rabattkod ${company.name}: ${campaign.heading}`">
        <meta name="og:title" :content="`Rabattkod ${company.name}: ${campaign.heading}`">
        <meta v-if="!campaign.main_image" property="og:image" :content="`${$page.props.baseUrl}${fallbackImage}`">
        <meta v-if="campaign.main_image" property="og:image" :content="campaign.main_image">
    </inertia-head>

    <card-modal type="local" ref="campaignNotExistsModal" title="Ooops!">
        Erbjudandet finns tyvärr inte kvar. Tryck på knappen för fler dunderdeals!

        <button @click="closeCampaignNotExistsModal" class="btn btn-danger mt-4">Hitta fler rabatter</button>
    </card-modal>

    <div v-if="!campaign" style="background-color:#f2fafd;">
        <main role="main" class="company" style="height: 100vh;" v-bind:class="{ container: !$isMobile, 'main': !campaignSlug, 'mt-0': campaignSlug}"></main>
    </div>

    <div v-if="campaign" style="background-color:#f2fafd;">
        <breadcrumb v-if="!campaignSlug">
            <breadcrumb-item>
                <inertia-link href="/">Hem</inertia-link>
            </breadcrumb-item>
            <breadcrumb-item>
                <inertia-link :href="`/${company.slug}`">{{ company.name }}</inertia-link>
            </breadcrumb-item>
            <breadcrumb-item :last="true">
                {{ campaign.heading }}
            </breadcrumb-item>
        </breadcrumb>

        <main role="main" class="company" v-bind:class="{ container: !$isMobile, 'main': !campaignSlug, 'mt-0': campaignSlug}">
            <div class="company-info campaign-page">

                <div class="campaigninner">

                <div style="position: relative;">
                    <div
                        @click="toggleFavorite"
                        style="position: absolute; right: 0; width: 48px; height: 48px; z-index: 90; display: flex; align-items: center; justify-content: center;">
                        <svg xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px;" :fill="hasFavoritedCampaign ? '#E05054' : '#F2FAFD'" viewBox="0 0 24 24" stroke="currentColor">
                            <path :stroke="hasFavoritedCampaign ? '#E05054' : '#F2FAFD'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                    </div>

                    <div
                        v-if="campaign.main_image"
                        class="cimagecontainer-camp"
                        :style="{ 'background-image': 'url('  + campaign.main_image + ')' }">
                    </div>
                </div>

                <img
                    v-if="!campaign.main_image"
                    class="main-image full"
                    :src="fallbackImage"
                    :alt="`${company.name} Kampanjbild Fallback`" />

                <div class="logo-rounded">
                    <inertia-link :href="`/${company.slug}`">
                        <img
                            v-if="company.company_logo_image"
                            :src="company.company_logo_image"
                            :alt="`${company.name} Logga`">
                    </inertia-link>
                </div>

                    <h1 v-if="!campaignSlug" class="name px-4 mb-md-4" style="margin-top: 0;margin-bottom: 20px;">
                        {{ campaign.heading }}
                    </h1>

                    <h2 v-if="campaignSlug" class="name px-4 mb-md-4">
                        {{ campaign.heading }}
                    </h2>

                    <p class="m-0" v-if="!campaignSlug">
                        <button v-if="['webshop-one-code-per-member', 'webshop-general-code', 'webshop-first-come-first'].includes(campaignTypeSlug)" class="btn btn-outline-dark mb-4" @click="claimCoupon">
                            Kopiera rabattkod
                        </button>

                        <a v-if="isLoggedIn && ['webshop-external-url', 'local-external-url'].includes(campaignTypeSlug)" class="btn btn-outline-dark mb-4" :href="couponCode" target="_blank">
                            Använd nu
                        </a>

                        <button v-if="!isLoggedIn && ['webshop-external-url', 'local-external-url'].includes(campaignTypeSlug)" class="btn btn-outline-dark mb-4" @click="login">
                            Använd nu
                        </button>

                        <button v-if="['local-general-code', 'local-one-code-per-member', 'local-barcode', 'webshop-barcode', 'local-first-come-first'].includes(campaignTypeSlug)" class="btn btn-outline-dark mb-4" @click="claimCoupon">
                            Visa i kassan
                        </button>
                    </p>

                    <div style="font-family: AvertaLight;" class="description pb-3 paddingx whitespace-pre-line break-words" v-if="!readMore &&  campaign.description" v-html="campaign.description"></div>
                    <span style="font-family: AvertaLight;" class="cursor-pointer d-inline-block mb-3" v-if="!readMore  && campaign.description && campaign.description != null && campaign.description.length > 1000" @click="readMore = !readMore"><u>läs mer</u></span>
                    <div style="font-family: AvertaLight;" class="description pt-2 pb-3 paddingx whitespace-pre-line" v-if="readMore" v-html="campaign.description"></div>

                    <p v-if="campaignSlug">
                        <inertia-link
                            v-if="campaignSlug"
                            :href="`/${company.slug}/${campaign.public_id}-${campaign.slug}`"
                            class="btn btn-outline-dark">
                            Till dealen
                        </inertia-link>
                    </p>

                    <div v-if="campaign.end_date" class="offer">
                        <span class="text-bold" >{{ $t('limited_time_offer') }}</span>
                        <span>{{ $t('valid_until') }} {{ endDateFormatted }}</span>
                    </div>

                    <div v-if="currentUser && currentUser.type === 'superadmin'" style="margin-bottom: 25px;">
                        <a :href="`/rule/campaign/${campaign.id}`">
                            <i class="fas fa-grip-lines fa-lg"></i>
                        </a>
                    </div>

                    <div class="text-center" v-if="!campaignSlug">
                        <h3 style="font-size: 14px; color: #D15A5A; font-family: AvertaBold;" class="mb-3">Dela</h3>

                        <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`" target="_blank">
                            <i class="fab fa-facebook-f" style="font-size: 24px;"></i>
                        </a>

                        <a :href="`sms:?&body=Kolla detta erbjudande ifrån ${company.name} på Familjekortet.se! ${shareUrl}`" target="_blank" class="ms-2">
                            <i class="fas fa-sms" style="font-size: 24px;"></i>
                        </a>

                        <a :href="`mailto:?subject=Kolla detta erbjudande ifrån ${company.name} på Familjekortet.se!&body=Kolla detta erbjudande ifrån ${company.name} på Familjekortet.se! ${shareUrl}`" target="_blank" class="ms-2">
                            <i class="far fa-envelope" style="font-size: 24px;"></i>
                        </a>

                        <input type="text" id="inputWithCopyableUrl" :value="rawShareUrl" style="position: absolute; z-index: -1; opacity: 0;">

                        <a href="javascript:void(0)" @click="copyCampaignLinkToClipboard" class="ms-2">
                            <i class="fas fa-link" style="font-size: 24px;"></i>
                        </a>
                    </div>
              </div>

            </div>

            <div style="display: grid;place-items: center;padding-bottom:30px;" v-if="!campaignSlug">

                <inertia-link :href="`/${company.slug}`" class="d-block">
                    <h1 style="font-size: 14px; text-transform: none; font-family: AvertaRegular; margin: 0px;">Läs mer om {{company.name}} här</h1>
                </inertia-link>
            </div>
        </main>

        <webshop-checkout
            v-if="campaign.slug && campaign.type === 'webshop'"
            ref="webshop-checkout"
            :campaign="campaign"
            :company="company"
            :company-images="{ company_logo_image: company.company_logo_image }">>
        </webshop-checkout>

        <local-general-code
            v-if="campaign.id && campaignTypeSlug === 'local-general-code'"
            ref="local-general-code"
            :campaign="campaign"
            :company="company"
            :company-images="{ company_logo_image: company.company_logo_image }">
        </local-general-code>

        <local-one-code-per-member
            v-if="campaign.id && campaignTypeSlug === 'local-one-code-per-member'"
            ref="local-one-code-per-member"
            :campaign="campaign"
            :company="company"
            :company-images="{ company_logo_image: company.company_logo_image }">
        </local-one-code-per-member>

        <local-first-come-first
            v-if="campaign.id && campaignTypeSlug === 'local-first-come-first'"
            ref="local-first-come-first"
            :campaign="campaign"
            :company="company"
            :company-images="{ company_logo_image: company.company_logo_image }">
        </local-first-come-first>

        <!-- <local-external-url
            v-if="campaign.id && campaignTypeSlug === 'local-external-url'"
            ref="local-external-url"
            :campaign="campaign"
            :company="company"
            :company-images="{ company_logo_image: company.company_logo_image }">
        </local-external-url> -->

        <local-barcode
            v-if="campaign.id && ['local-barcode', 'webshop-barcode'].includes(campaignTypeSlug)"
            ref="local-barcode"
            :campaign="campaign"
            :company="company"
            :company-images="{ company_logo_image: company.company_logo_image }">
        </local-barcode>

    <!-- COUPON CODE MODAL -->
    <div class="modal fade" id="ifNotSignedInModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog coupon-modal" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="logo-rounded" style="margin:0 auto 0 auto;">
                    <a href="javascript:void(0)">
                        <img
                            v-if="company.company_logo_image"
                            :src="company.company_logo_image"
                            :alt="`${company.name} Kampanjbild Fallback`">
                    </a>
                </div>

                <p class="discount-text">{{ $filters.truncate(campaign.heading, 300, '...') }}</p>
                <!-- <p class="discount-text">{{ campaign.name }}</p> -->

                <button class="btn btn-danger w-100 my-2" @click="login">{{ $t('login') }} </button>
                <button class="btn btn-outline-danger bg-light-blue w-100" @click="register">{{ $t('register') }}</button>

                <p class="if-not-signed-in-text">
                    Har du inget Familjekort?
                    No worries, det är gratis och tar en minut att registrera sig.
                </p>

            </div>
        </div>
    </div><!-- END COUPON CODE MODAL -->
    </div>
</template>

<script>
    import WebshopGeneralCode from '@/components/coupon-modals/WebshopGeneralCode';
    import WebshopOneCodePerMember from '@/components/coupon-modals/WebshopOneCodePerMember';
    import WebshopFirstComeFirst from '@/components/coupon-modals/WebshopFirstComeFirst';
    import WebshopExternalUrl from '@/components/coupon-modals/WebshopExternalUrl';

    import LocalGeneralCode from '@/components/coupon-modals/LocalGeneralCode';
    import LocalOneCodePerMember from '@/components/coupon-modals/LocalOneCodePerMember';
    import LocalFirstComeFirst from '@/components/coupon-modals/LocalFirstComeFirst';
    import LocalExternalUrl from '@/components/coupon-modals/LocalExternalUrl';
    import LocalBarcode from '@/components/coupon-modals/LocalBarcode';

    import CardModal from '@/components/CardModal';
    import { router } from '@inertiajs/vue3'
    import { getFallbackImage } from '@/Util/images';
    import { copyTextToClipboard } from '@/services/clipboard';
    import { toggleCampaignAsFavorite, hasFavoritedCampaign } from '@/services/favorites';

    import WebshopCheckout from '@/components/WebshopCheckout';

    import { DateTime } from 'luxon';

    export default {
        props: ['campaignSlug', 'campaign', 'company', 'canonical', 'title'],
        inject: ['$isMobile'],
        components: {
            CardModal,
            WebshopCheckout,
            LocalGeneralCode, LocalOneCodePerMember, LocalFirstComeFirst, LocalExternalUrl, LocalBarcode,
        },
        data() {
            return {
                couponCode: null,
                readMore: false,
                campaignTypeSlug: null,
                fallbackImage: null,
                hasFavoritedCampaign: false,
            }
        },
        watch: {
            currentUser: {
                deep: true,
                handler(val, oldVal) {
                    if (this.isLoggedIn && ['local-external-url', 'webshop-external-url'].includes(this.campaignTypeSlug)) {
                        this.claimCouponCode();
                    }
                }
            }
        },
        computed: {
            rawShareUrl() {
                return window.location.href;
            },
            shareUrl() {
                return encodeURIComponent(window.location.href);
            },
            currentUser() {
                return this.$page.props.currentUser;
            },
            isLoggedIn() {
                return this.$page.props.currentUser !== null;
            },
            endDateFormatted() {
                return DateTime.fromISO(this.campaign.end_date).toISODate();
            }
        },
        mounted () {
            window.scrollTo(0, 0);

            this.hasFavoritedCampaign = hasFavoritedCampaign(this.campaign.slug);
            this.fallbackImage = getFallbackImage();

            if (this.campaign) {
                this.campaignTypeSlug = `${this.campaign.type}-${this.campaign.couponCodeType.type}`.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase();
            } else {
                this.$refs.campaignNotExistsModal.show();
            }

            if (['local-external-url', 'webshop-external-url'].includes(this.campaignTypeSlug) && this.isLoggedIn) {
                this.claimCouponCode();
            }
        },
        methods: {
            async toggleFavorite() {
                this.hasFavoritedCampaign = !this.hasFavoritedCampaign;

                await toggleCampaignAsFavorite(this.campaign.slug);

                if (this.hasFavoritedCampaign) {
                    this.$moshaToast('Kampanjen har lagts till i dina favoriter!', {
                        type: 'success',
                        timeout: 2000,
                    });
                }
            },

            async copyCampaignLinkToClipboard () {
                await copyTextToClipboard(document.getElementById('inputWithCopyableUrl'));

                this.$moshaToast('Länken har kopierats!', {
                    type: 'success',
                    timeout: 2000,
                });
            },
            closeCampaignNotExistsModal () {
                this.$refs.campaignNotExistsModal.hide();
                setTimeout(() => router.visit(`/kampanjer`), 300);
            },
            claimCoupon () {
                if (!this.isLoggedIn) {
                    this.login();
                    return;
                }

                if (this.campaignTypeSlug === 'webshop-barcode') {
                    this.$refs['local-barcode'].start();
                    return;
                }

                if (this.campaign.type === 'local') {
                    this.$refs[this.campaignTypeSlug].start();
                } else {
                    const ref = this.campaign.type === 'webshop' ? 'webshop-checkout' : 'local-checkout';
                    this.$refs[ref].start();
                }
            },
            claimCouponCode(){
                axios.get('/api/site/campaign/claimcode/' + this.campaign.id).then(response => {
                    this.couponCode = response.data.data;
                });
            },
            useCode(){
                if (this.isLoggedIn) {
                    this.claimCouponCode();
                    $("#couponModal").modal("hide");
                    $("#uniqueCouponModal").modal("show");
                }else{
                    $("#couponModal").modal("hide");
                    $("#ifNotSignedInModal").modal("show");
                }
            },
            login(){
                $("#ifNotSignedInModal").modal("hide");
                $("#loginModal").modal("show");
            },
            register(){
                $("#ifNotSignedInModal").modal("hide");
                $("#registerModal").modal({
                    backdrop: 'static',
                    keyboard: false
                });
            }
        }
    }
</script>
